import { InviteeStatusEnum } from '../../models/jobInviteeStatusEnum';

export function getDispoActionRequiredBookableJobQuery(customerId: string): object {
  return {
    invitees: {
      $elemMatch: {
        status: {
          $in: [
            InviteeStatusEnum.AVAILABLE,
            InviteeStatusEnum.POSSIBLE_CANDIDATE,
            InviteeStatusEnum.PARTIAL_AVAILABLE,
          ],
        },
        'customer.id': customerId,
      },
    },
  };
}

export function getDispoActionRequiredTransferCandidateJobQuery(
  customerId: string,
): object {
  return {
    'customer.id': customerId,
    invitees: {
      $elemMatch: {
        status: InviteeStatusEnum.POSSIBLE_CANDIDATE,
        'customer.id': { $ne: customerId },
      },
    },
  };
}

export function getDispoActionRequiredNoOpenInviteesJobQuery(
  customerId: string,
): object {
  return {
    $and: [
      {
        invitees: {
          $not: {
            $elemMatch: {
              status: {
                $in: [
                  InviteeStatusEnum.OPEN,
                  InviteeStatusEnum.POSSIBLE_CANDIDATE,
                ],
              },
              'customer.id': customerId,
            },
          },
        },
      },
      {
        $nor: [
          getDispoActionRequiredBookableJobQuery(customerId),
          getDispoActionRequiredTransferCandidateJobQuery(customerId),
        ],
      },
    ],
  };
}

/**
 * Returns a MongoDB query object to find jobs that require action from a DISPO user
 * for a specific customer.
 * This means jobs where:
 * - Invitees are AVAILABLE or PARTIAL_AVAILABLE for the customer.
 * - Or, invitees are POSSIBLE_CANDIDATE where the job is owned by the customer AND the invitee is NOT from the job's own customer (i.e., it's a transfer/agency submission).
 * - Or, there are no OPEN invitees for the customer (implying all have other statuses or no invitees yet).
 * @param customerId The ID of the customer.
 * @returns MongoDB query object.
 */
export function getDispoActionRequiredJobQuery(customerId: string): object {
  return {
    $or: [
      {
        invitees: {
          $elemMatch: {
            status: {
              $in: [
                InviteeStatusEnum.AVAILABLE,
                InviteeStatusEnum.PARTIAL_AVAILABLE,
              ],
            },
            'customer.id': customerId,
          },
        },
      },
      getDispoActionRequiredTransferCandidateJobQuery(customerId),
      getDispoActionRequiredNoOpenInviteesJobQuery(customerId),
    ],
  };
}
